import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TitlePage = ({ children, Icon }) => {
  const theme = useTheme()

  return (
    <Styles.Container>
      {Icon && <Icon size={24} weight="light" color={theme.colors.outline.default} />}
      <Text type="titleM" color={theme.colors.outline.default}>
        {children}
      </Text>
    </Styles.Container>
  )
}

export default TitlePage
